import { message } from "antd";
import { getMe, login } from ".";
import { useAuthStore } from "@/shared/store/useAuthStore";
import i18next from "i18next";

export async function loginHandler(data: {
  username: string;
  password: string;
}) {
  const res = await login(data);

  if (!res) {
    message.error(i18next.t("auth.login_fail"));
    return;
  }

  localStorage.setItem("access_token", res.access);
  localStorage.setItem("refresh_token", res.refresh);

  const user = await getMe();

  useAuthStore.setState({ isAuth: true, user });
  message.success(i18next.t("auth.login_success"));
}

export function logoutHandler() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");

  useAuthStore.setState({ isAuth: false, user: null });
  message.success(i18next.t("auth.logout_success"));
}
